/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TrashIcon } from '../../../Icons';
import Loading from '../../../Loading/loading';
import { RadioButton } from '../../../RadioButton';
import * as Ui from './styles';

const propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
  selectable: PropTypes.bool,
  onTrash: PropTypes.func,
  onClick: PropTypes.func,
};

const defaultProps = {
  title: 'Your title here',
  data: [
    { value: 'key#1', label: 'Data #1' },
    { value: 'key#2', label: 'Data #2' },
  ],
  selectable: false,
  onTrash: null,
  onClick: null,
};

export default function MiniCard(props) {
  const { title, selectable, isLoading, data, onTrash, onClick } = props;
  const [showListView, setShowListView] = useState(true);
  // TODO: no futuro, a solucao sera externalizar o controle de estado, vai ser util em caso de edicao de itens
  const [selectedItem, setSelectedItem] = useState(null);

  function handleTrashClick() {
    if (onTrash) onTrash();
  }

  function handleClick(subItemId) {
    if (onClick) onClick(subItemId);
    setSelectedItem(subItemId);
  }

  function renderData(isLoading, data) {
    if (isLoading) {
      return (<Loading size={20} running />);
    }
    return data.map((item) => (
      <Ui.ListItem key={item.value}>
        {selectable ? (
          <RadioButton
            dark
            id={`option-${item.value}`}
            name={title}
            label={item.label}
            value={item.value}
            checked={selectedItem === item.value}
            onChange={() => handleClick(item.value)}
          />
        ) : item.label}
      </Ui.ListItem>
    ));
  }

  function renderList() {
    return selectable ? (
      <Ui.ListWithBullet className="list">
        {renderData(isLoading, data)}
      </Ui.ListWithBullet>
    ) : (
      <Ui.List className="list">
        {renderData(isLoading, data)}
      </Ui.List>
    );
  }

  return (
    <Ui.Container className="minicard-wrapper">
      <Ui.Header className="header">
        <Ui.Title onClick={() => setShowListView(!showListView)}>{title}</Ui.Title>
        <Ui.TrashButton iconComponent={TrashIcon} iconSize={20} onClick={handleTrashClick} />
      </Ui.Header>
      {showListView && renderList()}
    </Ui.Container>
  );
}

MiniCard.propTypes = propTypes;
MiniCard.defaultProps = defaultProps;
